// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3UwVC","colMin":"styles_colMin__1ejYH"};